<div class="wrapper-md">
    <app-breadcrumbs [items]="[{ url: '/notifications', text: 'notification_listTitle' }]"></app-breadcrumbs>

    <header class="content-header">
        <h1>{{'notification_listTitle' | translate}}</h1>
    </header>

    <ul ngbNav #nav="ngbNav" [(activeId)]="activeTabId" class="nav-tabs">
        <li *ngFor="let t of tabs; let i = index" [ngbNavItem]="i + 1">
            <a ngbNavLink>{{t.title | translate}}</a>
            <ng-template ngbNavContent>
                <div class="mt-3">
                    <app-notification-outbox *ngIf="t.id == 'outbox'"></app-notification-outbox>
                    <app-notification-inbox *ngIf="t.id == 'inbox'"></app-notification-inbox>
                    <app-notification-channels *ngIf="t.id == 'channels'"></app-notification-channels>
                </div>
            </ng-template>
        </li>
    </ul>
    <div [ngbNavOutlet]="nav"></div>
</div>
